export default {
    init: (app, gsap, SplitText, Kira) => {
        /*
        |
        | Loader
        |---------
        */
        const loader = document.querySelector('.page-loader')

        if (sessionStorage.getItem('loaded_once') === null) {
            sessionStorage.setItem('loaded_once', 'loaded_once')
        }

        if (!loader.hidden) {
            const loaderTl = gsap.timeline({ paused: true })

            loaderTl.to(loader.querySelector('.page-loader-progress-bar'), {
                scaleX: 1,
                duration: .4,
                ease: 'Power0.easeNone'
            }, 'start')

            loaderTl.call(() => { app.dispachEvent(document.body, 'dom:ready') }, null)

            loaderTl.to(loader, {
                autoAlpha: 0,
                duration: .8,
                delay: .3,
                ease: 'Power1.easeOut'
            })

            addEventListener('load', () => loaderTl.play())
        } else {
            addEventListener('load', () => app.dispachEvent(document.body, 'dom:ready'))
        }



        /*
        |
        | SplitText
        |------------
        */
        document.querySelectorAll('[data-split-text]').forEach((item) => {
            item.split = new SplitText(item, {
                type: item.dataset.splitText ? item.dataset.splitText : 'words, chars',
                linesClass: 'split-line',
                wordsClass: 'split-word',
                charsClass: 'split-char'
            })

            item.classList.add('split-ready')
        })

        /*
        |
        | Kira
        |-----------
        */
        const kira = new Kira({
            loadEvent: [document.body, 'dom:ready'],
            scrollTrigger: {
                markers: false,
                //scroller: scrollContainerSelector,
            },
            tweenParams: {
                start: '-=0.6'
            }
        })

        /*
        |
        | Kira
        |-----------
        */
        const kira2 = new Kira({
            loadEvent: [document.body, 'dom:ready'],
            scrollTrigger: {
                markers: false,
                //scroller: scrollContainerSelector,
            },
            tweenParams: {
                start: '-=0'
            }
        })

        /*
        | fade-in-up
        |-----------
        */
        kira.add('fade-in-up', (item, timeline, start, duration) => {
            timeline.fromTo(item, {
                y: 50
            }, {
                y: 0,
                autoAlpha: 1,
                duration: duration || 1.3,
                ease: 'easeSmooth'
            }, start)
        })

        /*
        | fade-in-up
        |-----------
        */
        kira.add('fade-in-up-alt', (item, timeline, start, duration) => {
            timeline.fromTo(item, {
                y: 50
            }, {
                y: 0,
                autoAlpha: 1,
                duration: duration || 0.7,
                ease: 'easeSmooth'
            }, start)
        })

        /*
        | anim 3 cols
        |-----------
        */
        kira.add('fade-anim', (item, timeline, start, duration) => {
            // Assurez-vous que l'élément est positionné correctement pour l'animation (vous pourriez avoir besoin d'ajuster cela selon votre CSS)
            gsap.set(item, { autoAlpha: 0, width: '0%', y: '+=30' });

            timeline.fromTo(item, {
                autoAlpha: 0, // Démarre invisible
                width: '50%', // Démarre avec une largeur de 0%
                y: '0' // Commence 30px plus haut que sa position finale
            }, {
                autoAlpha: 1, // Fini visible
                width: '100%', // Fini avec une largeur de 100%
                y: '+=30', // Fini à sa position verticale initiale
                duration: duration || 1, // Durée de l'animation, ou 1.5 secondes par défaut
                ease: 'easeSmooth'
            }, start);
        });


        // Animation pour value-parent de gauche à droite
        kira.add('fade-in-left-to-right', (item, timeline, start, duration) => {
            timeline.fromTo(item, {
                autoAlpha: 0,
                x: -50 // Déplacement initial sur l'axe X
            }, {
                x: 0, // Position finale sur l'axe X
                autoAlpha: 1,
                duration: duration || 1.3,
                ease: 'easeSmooth'
            }, start);
        });

        // Animation pour value-child de haut en bas
        kira.add('fade-in-top-to-bottom', (item, timeline, start, duration) => {
            timeline.fromTo(item, {
                autoAlpha: 0,
                y: 0 // Déplacement initial sur l'axe Y
            }, {
                y: 0, // Position finale sur l'axe Y
                autoAlpha: 1,
                duration: duration || 1.3,
                ease: 'easeSmooth'
            }, start);
        });


        /*
        | fade-in
        |-----------
        */
        kira.add('fade', (item, timeline, start, duration) => {
            timeline.fromTo(item, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                duration: duration || 1,
                ease: 'easeSmooth'
            }, start);
        });

        /*
        | split-line
        |------------
        */
        kira.add('split-lines', (item, timeline, start, duration, delay) => {
            timeline.from(item.split.words ? item.split.words : item.split.chars, {
                yPercent: 101,
                delay: delay || 0,
                duration: duration || 1.35,
                ease: 'easeSmooth'
            }, start)
        })

        /*
        | split-chars
        |-----------------
        */
        kira.add('split-chars', (item, timeline, start, duration, delay) => {
            const stagger = item.hasAttribute('data-kira-stagger') ? parseFloat(item.dataset.kiraStagger) : .03

            timeline.from(item.split.chars, {
                opacity: 0,
                yPercent: 30,
                delay: delay || 0,
                duration: duration || .2,
                stagger: stagger,
                ease: 'Sine.ease0ut'
            }, start)
        })

        /*
        | counter
        | data-decimal-separator to chose decimal separator (defaults to ",")
        | data-thousands-separator to chose thousands separator (defaults to " ")
        |-----------------
        */
        kira.add('counter', (item, timeline, start, duration, delay) => {
            const decimalSeparator = item.hasAttribute('data-decimal-separator') ? item.dataset.decimalSeparator : ','
            const thousandsSeparator = item.hasAttribute('data-thousands-separator') ? item.dataset.thousandsSeparator : ' '

            let goal = item.textContent.replaceAll(',', '.').replaceAll(' ', '')
            let counter = { val: 0 }

            let decimals = goal.split('.')[1]
            let toFixed = decimals ? decimals.length : false

            goal = toFixed ? parseFloat(goal) : parseInt(goal)

            const inner = document.createElement('span')
            inner.classList.add('counter-value')

            item.setAttribute('data-counter-goal', item.textContent)
            item.textContent = ''
            item.appendChild(inner)

            timeline.to(counter, {
                val: goal,
                duration: duration || 1.3,
                delay: delay || 0,
                ease: 'easeSmooth',
                onUpdate: () => {
                    let val = 0

                    if (toFixed) {
                        let [number, decimals] = counter.val.toFixed(toFixed).toString().split('.', 2)
                        number = number.replaceAll(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
                        val = [number, decimals].join(decimalSeparator)
                    } else {
                        val = Math.round(counter.val).toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
                    }

                    inner.textContent = val
                }
            }, start)
        })

        kira.init()
    }
}